export default () => ({
  root: {
    height: '2.2rem',
    minWidth: '2.2rem',
    borderRadius: '2rem',
  },
});
